export function formatPublishedAt(value) {
    if (!value) return null;

    if (typeof value === 'object' && typeof value.toDate === 'function') {
        return value.toDate().toISOString();
    }

    if (value instanceof Date) {
        return value.toISOString();
    }

    if (typeof value === 'number' || typeof value === 'string') {
        return value;
    }

    return null;
}

export function toDate(value) {
    if (!value) return null;

    if (typeof value === 'object' && typeof value.toDate === 'function') {
        return value.toDate();
    }

    if (value instanceof Date) {
        return value;
    }

    if (typeof value === 'number' || typeof value === 'string') {
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
}

export function getDaysSinceDate(value, nowMs = Date.now()) {
    const selectedDate = toDate(value);
    if (!selectedDate) return null;

    const msInDay = 24 * 60 * 60 * 1000;
    const diffMs = nowMs - selectedDate.getTime();
    return Math.max(0, Math.floor(diffMs / msInDay));
}

